// extracted by mini-css-extract-plugin
export default {"item":"Styles_item__FV54l","title":"Styles_title__t05af","price":"Styles_price__5+faI"};